import React from "react";
import styled from "styled-components";

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

const Th = styled.th`
  text-align: left;
  padding: 10px 8px;
  border-bottom: 2px solid #ddd;
  color: #666;
  font-weight: 600;
`;

const Td = styled.td`
  padding: 8px;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    padding: 6px;
  }
`;

const Tr = styled.tr`
  &:hover {
    background: #f9f9f9;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const ZeroResultQueries = ({ data, loading }) => {
  if (loading) {
    return <LoadingMessage>Loading...</LoadingMessage>;
  }

  if (!data || data.length === 0) {
    return <LoadingMessage>No zero-result queries found.</LoadingMessage>;
  }

  return (
    <TableScrollWrapper>
    <Table>
      <thead>
        <tr>
          <Th>#</Th>
          <Th>Keywords</Th>
          <Th>Cuisine</Th>
          <Th>Count</Th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <Tr key={index}>
            <Td>{index + 1}</Td>
            <Td>{item.keywords || "(none)"}</Td>
            <Td>{item.cuisine || "(any)"}</Td>
            <Td>{item.count.toLocaleString()}</Td>
          </Tr>
        ))}
      </tbody>
    </Table>
    </TableScrollWrapper>
  );
};

export default ZeroResultQueries;
